var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{attrs:{"aria-live":"polite","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.count)+" "+_vm._s(_vm.count === 1 ? "résultat" : "résultats"))])}
var staticRenderFns = []

export { render, staticRenderFns }